// Site Loading 
var flag = true;
$(window).on('load', function() {
   
    $("#splash").delay(1000).fadeOut('slow', function() { //ローディングエリア（splashエリア）を1.5秒でフェードアウトする記述
        $('body').addClass('appear'); //フェードアウト後bodyにappearクラス付与
        
          
          });
      
    });
    //=====ここから背景が伸びた後に動かしたいJSをまとめたい場合は
    $('.splashbg').on('animationend', function() {        
        $('.fv_img').addClass('animation1');        
        $('.first_view .fv_txt').addClass('animation2');
        $('.first_view .fv_txt p').addClass('animation3');
        setTimeout(function() {
             $('.first_view .fv_slide').slick({
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              fade: true,
              speed: 1500,
              autoplaySpeed: 3000,
              autoplay: true,
              // pasueOnFocus: false,
              // pauseOnHover: false,
              draggable: true,
              touchThreshold: 1000
          });
        }, 1500);
       
         // if (!localStorage.getItem("modal")) {
            // $(".modal1").delay(5000).fadeIn(1000);
         // }
         // localStorage.setItem("modal", 'true');
         $(".modal1").delay(6000).fadeIn(1000);
         // FV
         

    //=====ここまで背景が伸びた後に動かしたいJSをまとめる
    // $('.fv_img').delay(1500).addClass('animation1');
});

try {
    // Modal Setup
    var modal1 = document.getElementById('modal1');

    var modalClose1 = document.getElementById('modal-close1');
    modalClose1.addEventListener('click', function() {
        modal1.style.display = "none";
    });
    window.onclick = function(event) {
        if (event.target == modal) {
            modal1.style.display = "none";
        }
    }

} catch (error) {
}    
  
$('.first_view .fv_slide').on('touchstart', e => {
  $('.first_view .fv_slide').slick('slickPlay');
});
// TOP 
var btn = $('.back-to-top');

$(window).scroll(function() {
    fadeIn();
    if ($(window).scrollTop() > 1600) {
        btn.addClass('show');
    } else {
        btn.removeClass('show');
    }
});
$(window).scroll(function() {
    if ($(window).scrollTop() > 0) {
        $(".header").addClass('header_bg');
    } else {
        $(".header").removeClass('header_bg');
    }
});

btn.on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({
        scrollTop: 0
    }, '300');
});

// ハンバーガーメニュー 
var i = 1;

function openNav(x) {
    i++;
    x.classList.toggle("change");
    if (i % 2 != 1) {
        $('.nav_container').fadeIn();
        document.getElementById("myNav").style.right = "0%";
        $('body').css('overflow', 'hidden');
        $(".menu_btn .container").css("position", "fixed");
    } else {
        $('.nav_container').fadeOut();
        document.getElementById("myNav").style.right = "-100%";
        $('body').css('overflow', 'auto');
        $(".menu_btn .container").css("position", "initial");
    }
}

// FV slide

$('.message_card .card_slide').slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        }
    ]
});

function fadeIn() {

    $('.img-animation-wrapper').each(function() { //fadeUpTriggerというクラス名が
        var elemPos = $(this).offset().top; //要素より、50px上の
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
        if (scroll >= elemPos - windowHeight) {
            $(this).addClass('img-animated');
            // 画面内に入ったらfadeUpというクラス名を追記
        } else {
            // $(this).removeClass('img-animated');
        }
    });

}

// FQA
const items = document.querySelectorAll(".accordion button");

function toggleAccordion() {
    const itemToggle = this.getAttribute('aria-expanded');

    for (k = 0; k < items.length; k++) {
        items[k].setAttribute('aria-expanded', 'false');
    }

    if (itemToggle == 'false') {
        this.setAttribute('aria-expanded', 'true');
    }
}

items.forEach(item => item.addEventListener('click', toggleAccordion));


$(".guide_page .qa_tab a").on('click', function(event) {
    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {

        var hash = this.hash;

        $('html, body').animate({
            scrollTop: $(hash).offset().top - 100
        }, 300, function() {

            window.location.hash = hash;
        });
    }
});

var j = 1;

function submenu(x) {
    j++;
    x.classList.toggle("active");
    if (j % 2 != 1) {
        $('.sp_nav .sub_menu').css('opacity', '1');
        $(".sp_nav .sub_menu").css("max-height", "10em");
    } else {
        $('.sp_nav .sub_menu').css('opacity', '0');
        $(".sp_nav .sub_menu").css("max-height", "0");
    }
}



try {
    // Modal Setup
    var modal = document.getElementById('modal');

    var modalClose = document.getElementById('modal-close');
    modalClose.addEventListener('click', function() {
        modal.style.display = "none";
    });
    window.onclick = function(event) {
        if (event.target == modal) {
            modal.style.display = "none";
        }
    }

} catch (error) {

}

// global handler
document.addEventListener('click', function(e) {
    if (e.target.className.indexOf('modal-target') !== -1) {
        var img = e.target;
        var modalImg = document.getElementById("modal-content");
        var captionText = document.getElementById("modal-caption");
        modal.style.display = "block";
        modalImg.src = img.src;
        captionText.innerHTML = img.alt;
    }
});


function slideAnime() {
    //====左に動くアニメーションここから===
    $('.leftAnime').each(function() {
        var elemPos = $(this).offset().top + 50;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
        if (scroll >= elemPos - windowHeight) {
            //左から右へ表示するクラスを付与
            //テキスト要素を挟む親要素（左側）とテキスト要素を元位置でアニメーションをおこなう
            $(this).addClass("slideAnimeLeftRight"); //要素を左枠外にへ移動しCSSアニメーションで左から元の位置に移動
            $(this).children(".leftAnimeInner").addClass("slideAnimeRightLeft"); //子要素は親要素のアニメーションに影響されないように逆の指定をし元の位置をキープするアニメーションをおこなう
        } else {
            //左から右へ表示するクラスを取り除く
            $(this).removeClass("slideAnimeLeftRight");
            $(this).children(".leftAnimeInner").removeClass("slideAnimeRightLeft");

        }
    });
    //====右に動くアニメーションここから===
    $('.rightAnime').each(function() {
        var elemPos = $(this).offset().top + 50;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
        if (scroll >= elemPos - windowHeight) {
            // 右から左へ表示するクラスを付与
            // テキスト要素を挟む親要素（右側）とテキスト要素を元位置でアニメーションをおこなう
            $(this).addClass("slideAnimeRightLeft ");
            // 要素を右枠外にへ移動しCSS アニメーションで右から元の位置に移動
            $(this).children(".rightAnimeInner").addClass("slideAnimeLeftRight");
            // 子要素は親要素のアニメーションに影響されないように逆の指定をし元の位置をキープするアニメーションをおこなう
        } else {
            // 右から左へ表示するクラスを取り除く
            $(this).removeClass("slideAnimeRightLeft ");
            $(this).children(".rightAnimeInner").removeClass("slideAnimeLeftRight");
        }
    });

}

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function() {
    slideAnime(); /* アニメーション用の関数を呼ぶ*/
}); // ここまで画面をスクロールをしたら動かしたい場合の記述

// 画面が読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function() {
    slideAnime(); /* アニメーション用の関数を呼ぶ*/
}); // ここまで画面が読み込まれたらすぐに動かしたい場合の記述


$(window).on('load', function(){
  
  $("input[name='properties[生年月日]']").attr('type', 'date');
  $("input[name='properties[内容量(体重)]']").attr('placeholder', '0000g');
  $("input[name='properties[熨斗の用途]']").attr('placeholder', 'その他の方はご記入ください。');
  $("input[name='properties[熨斗送り主]").attr('placeholder', '名入れなしの方は「なし」とご記入ください。');
  $("textarea[name='properties[自由テキストのご入力]']").attr('placeholder', '２０文字×４行（８０文字）のテキストをご入力ください');
  $(".product-option .bcpo-cart-item-original-price").after('<span class="price_txt">税込</span>');
  // $("input[name='properties[画像アップロード]']").after('<p class="option_txt">あげ忘れ、入力漏れのない仕様</p>');
  $("input[name='properties[画像アップロード]']").attr("required", true);
  $(".bcpo-cart-original-total").text($(".bcpo-cart-original-total").text().trim().replace("JPY",""));
  $("input[name='properties[ポストカードの選択]']").on('change', function() {
   
    if (this.value == '芽 写真なし' || this.value == '動物 写真なし' || this.value == 'お花 写真なし') {
       $(".selector-wrapper.bcpo-file").addClass("remove");
       $("input[name='properties[画像アップロード]']").attr("required", false);
    }
    else if (this.value == '芽 写真あり' || this.value == '動物 写真あり' || this.value == 'お花 写真あり') {
         $(".selector-wrapper.bcpo-file").removeClass("remove");
         $("input[name='properties[画像アップロード]']").attr("required", true);
    }
  });

//let input = $("input[name='properties[お名前（お子様の）]");
let inputEvent = document.querySelector("input[name='properties[お名前（お子様の）]']");
let inputEvent1 = document.querySelector("input[name='properties[おなまえ(ひらがな)]']");


// disable event function
// const disableEvent = e => {
//   e.preventDefault();
//   e.stopPropagation();
// };
// try{
// disable paste
// inputEvent.addEventListener("paste", disableEvent);
// inputEvent1.addEventListener("paste", disableEvent);

// disable drag&drop
// inputEvent.addEventListener("drop", disableEvent);  
// inputEvent1.addEventListener("drop", disableEvent);  
// }
//   catch(err)
// {
// }

// inputEvent.addEventListener("keyup", function(e) {
//   let tmp = [];

//   this.value.split("").forEach(function(item, i) {    
//     if (item.match(/^[\u3040-\u309f]+$/)) {
//       tmp.push(item);
//     }
//   });

//   if (tmp.length > 0) {
//     this.value = tmp.join("");
//   } else {
//     this.value = "";
//   }
// });

// inputEvent1.addEventListener("keyup", function(e) {
//   let tmp = [];

//   this.value.split("").forEach(function(item, i) {    
//     if (item.match(/^[\u3040-\u309f]+$/)) {
//       tmp.push(item);
//     }
//   });

//   if (tmp.length > 0) {
//     this.value = tmp.join("");
//   } else {
//     this.value = "";
//   }
// });


});

